import { render, staticRenderFns } from "./cv-side-nav-divider.vue?vue&type=template&id=67695692&"
import script from "./cv-side-nav-divider.vue?vue&type=script&lang=js&"
export * from "./cv-side-nav-divider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports